import { HttpClient } from "@angular/common/http";
import { computed, Injectable, signal, Signal, WritableSignal } from "@angular/core";
import { environment } from "../../../environments/environment";
import { BehaviorSubject } from "rxjs";
import { AppTypeEnum } from "../enums";
import { TestLogModel } from "../models";

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    public static apiKey: WritableSignal<string | null> = signal(null);
    public static censoredKey: Signal<string | null> = computed(() => ApiService.apiKey() ? '*****' + ApiService.apiKey()!.substring(32) : null);
    public static locationCode: WritableSignal<string | null> = signal(null);
    public static location: WritableSignal<string | null> = signal(null);
    public static until: WritableSignal<string | null> = signal(null);


    private readonly _apiUrl = environment.apiUrl + 'pwa/tools';

    constructor(
        private http: HttpClient
    ) { }

    sendQrCode(qr_code: string) {
        return this.http.post<{ decodedText: string }>(this._apiUrl + `/qr_code_check`, { qr_code: qr_code })
    }

    sendImage(formData: FormData) {
        return this.http.post<{ unit: string }>(this._apiUrl + `/image_check`, formData)
    }

    testApiKey(key: string, locationCode: string) {
        return this.http.post<{ is_valid: boolean, valid_until: string }>(this._apiUrl + `/api_key_check`, { api_key: key, location_code: locationCode.toString() });
    }

    checkLocationCode(locationCode: string) {
        return this.http.get<{ id: number, name: string }>(this._apiUrl + `/get_location_name/${locationCode}`,);
    }

    bindMac(unit: string, qrCode: string) {
        const apiKey = ApiService.apiKey();
        const locationCode = ApiService.locationCode()?.toString();
        return this.http.post<any>(this._apiUrl + `/binding_mac_unit`, { api_key: apiKey, location_code: locationCode, unit: unit, qr_code: qrCode })
    }

    testLog(unit: string) {
        const locationCode = ApiService.locationCode();
        const apiKey = ApiService.apiKey();
        return this.http.post<{ check_list: TestLogModel }>(this._apiUrl + `/log_testing`, { api_key: String(apiKey), location_code: String(locationCode), unit: String(unit) })
    }
}